import React, { Component } from 'react';

export default class Contact extends Component {
  render() {
    return (
      <React.Fragment>
        <section id="contact" className="s-contact target-section">
          <div className="row s-contact__header">
            <div className="column large-12">
              <h3 className="section-header-allcaps">Say Hello</h3>
            </div>
          </div>
          <div className="row s-contact__content">
            <div className="column large-7 medium-12">
              <h4 className="huge-text">
                Want to reachout? Go ahead and contact me on LinkedIn to get in
                touch. If not, you can use my email and we can talk at an
                available time.
              </h4>
            </div>
            <div className="column large-4 medium-12">
              <div className="row contact-infos">
                <div className="column large-12 medium-6 tab-12">
                  <div className="contact-block">
                    <h5 className="contact-block__header">Email</h5>
                    <p className="contact-block__content">
                      <a className="mailtoui" href="mailto:hquan212@gmail.com">
                        hquan212@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="column large-12 medium-6 tab-12">
                  <div className="contact-block">
                    <h5 className="contact-block__header">Phone</h5>
                    <p className="contact-block__content">
                      <a href="tel:+1975432345">+919 737 5059</a>
                    </p>
                  </div>
                </div>
                <div className="column large-12">
                  <a
                    href="mailto:hquan212@gmail.com"
                    className="mailtoui btn btn--primary h-full-width"
                  >
                    Let's Talk
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
